export class Contact {
  country?: string;
  firstname?: string;
  address?: string;
  cp_id?: number;
  version_id?: number;
  given_name?: string;
  lastname?: string;
  dt?: string;
  telephone_no?: string;
  user_id?: number;
  patient_id?: number;
  family_name_surname?: string;
  version_status?: number;
  email?: string;
  status?: number;
  [key: string]: any;
}
